import { useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import CategoryShowcase from "@/components/CategoryShowcase";
import RecentStrip from "@/components/RecentStrip";
import AdBlock from "@/components/AdBlock";
import SearchResults from "@/components/SearchResults";

export default function Home() {
  const [query, setQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("");
  const isFiltering = Boolean(query.trim() || activeCategory);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <Hero
        query={query}
        setQuery={setQuery}
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
      />

      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-10">
        <AdBlock variant="banner" testId="ad-below-hero" />
      </div>

      {isFiltering ? (
        <SearchResults query={query} category={activeCategory} />
      ) : (
        <>
          <CategoryShowcase />
          <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-14 md:pt-20">
            <AdBlock variant="inline" testId="ad-between-sections" />
          </div>
          <RecentStrip limit={10} />
        </>
      )}

      <Footer />
    </div>
  );
}
